import React from "react";
import { Control } from "react-hook-form";
import { RegisterCompanyFormInput } from "@/components/pages/RegisterCompany/validation/registerCompanyValidationSchema";
import BankAccount from "@/components/molecules/RegisterCompanySteps/BankAccount";
import TransportResponsible from "@/components/molecules/RegisterCompanySteps/TransportResponsible";
import PaymentPreferences from "@/components/molecules/RegisterCompanySteps/PaymentPreferences";

interface EconomyAndLogisticsPanelProps {
  control: Control<RegisterCompanyFormInput>;
  saveDraft: () => Promise<void>;
}

const EconomyAndLogisticsPanel: React.FC<EconomyAndLogisticsPanelProps> = ({ control, saveDraft }) => {
  return (
    <React.Fragment>
      <BankAccount control={control} saveDraft={saveDraft} />
      <PaymentPreferences control={control} saveDraft={saveDraft} />
      <TransportResponsible control={control} saveDraft={saveDraft} />
    </React.Fragment>
  );
};

export default EconomyAndLogisticsPanel;
